const html: JQuery = $('html');
const transitionEvents: string = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';

export function isElementHidden($el: JQuery): boolean {
    return $el.hasClass('visually-hidden') && $el.hasClass('hidden');
}

export function waitForTransition($el: JQuery): Promise<JQuery> {
    if (!$el.is(':visible')) {
        return Promise.resolve($el);
    }
    return new Promise(resolve => {
        $el.one(transitionEvents, e => {
            e.stopPropagation();
            resolve($el);
        });
    });
}

export function addCssWithTransition($el: JQuery, property: string, value: string): Promise<JQuery> {
    $el.css(property, value);
    return waitForTransition($el);
}

export function addClassWithTransition($el: JQuery, className: string): Promise<JQuery> {
    if ($el.hasClass(className)) {
        return Promise.resolve($el);
    }
    $el.addClass(className);
    return waitForTransition($el);
}

export function removeClassWithTransition($el: JQuery, className: string): Promise<JQuery> {
    if (!$el.hasClass(className)) {
        return Promise.resolve($el);
    }
    $el.removeClass(className);
    return waitForTransition($el);
}

export function showElement($el: JQuery): Promise<JQuery> {
    if (!isElementHidden($el)) {
        return Promise.resolve($el);
    }

    $el.removeClass('hidden');
    return new Promise(resolve => {
        setTimeout(() => {
            removeClassWithTransition($el, 'visually-hidden').then(() => {
                resolve($el);
            });
        }, 20);
    });
}

export function hideElement($el: JQuery): Promise<JQuery> {
    if (isElementHidden($el)) {
        return Promise.resolve($el);
    }

    return addClassWithTransition($el, 'visually-hidden').then(() => {
        $el.addClass('hidden');
        return $el;
    });
}

export function lockScroll(): void {
    html.addClass('hide-vertical-scrollbar');
}

export function restoreScroll(): void {
    html.removeClass('hide-vertical-scrollbar');
}
